import Icon from "../assets/Logos/SkyGarden_Logo.svg"


export default function Logo({ sx }) {
  return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <img src={'https://rivieragroup.pk/static/media/logo.ad5f934eaa6169aa2e1f7e122eb2c39b.svg'} width={180}/>
      </div>
  );
}
